import './CustomMarker.css'
import React from "react";
import L, {LatLng} from "leaflet";
import {Marker, Popup} from "react-leaflet";
import {IonButton, IonIcon, IonModal} from "@ionic/react";
import {eye} from "ionicons/icons";
import CloseButton from "../../utils/buttons/CloseButton";

/**
 * Generates a marker with the chosen icon. It is placed at the provided position and contains a description in a popup.
 * It is also possible to add a modal to display more information.
 * @author Alizée Grand
 * @version 1.1
 * @creation 16/09/2021
 * @last_update 05/01/2022
 **/
class CustomMarker extends React.Component<{
    /**
     * Marker position.
     */
    position: LatLng,
    /**
     * Icon of the marker.
     */
    icon: L.Icon,
    /**
     * Content of the pop-up that appears when the marker is clicked.
     */
    descriptionInPopup: JSX.Element,
    /**
     * Contents of the modal window displayed when the user clicks on the "learn more" button on the marker pop-up.
     */
    elementInModal?: JSX.Element
}> {

    state = {
        showModal: false,
    }

    render() {

        /**
         * Shows the modal with more information
         */
        const onItemClick = () => {
            this.setState({showModal: true});
        };

        /**
         * Close the modal with more information
         */
        const onModalClick = () => {
            this.setState({showModal: false});
        };

        return (
            <Marker position={this.props.position} icon={this.props.icon}>
                <Popup>
                    {
                        this.props.descriptionInPopup
                    }
                    {
                        this.props.elementInModal ?
                            <IonButton size="small" color="primary" onClick={onItemClick}>
                                <IonIcon icon={eye}/>
                            </IonButton> : ""
                    }
                </Popup>
                <IonModal isOpen={this.state.showModal} onDidDismiss={onModalClick}>
                    <CloseButton onClickAction={onModalClick}/>
                    {
                        this.props.elementInModal
                    }
                </IonModal>
            </Marker>
        );
    }
}
export default CustomMarker;
